<template>
  <!-- 内部リンク -->
  <v-btn
    v-if="isInternal"
    :to="linkUrl"
    variant="outlined"
    class="mx-auto text-capitalize my-2"
    align="center"
    color="secondary"
    block
    height="120"
  >
    <div class="text-body1 text-sm-h5">{{ linkText }}</div>
  </v-btn>

  <!-- 外部リンク -->
  <v-btn
    v-else
    tag="a"
    :href="linkUrl"
    :target="isBlank ? '_blank' : null"
    :rel="isBlank ? 'noopener noreferrer' : null"
    variant="outlined"
    class="mx-auto text-capitalize my-2"
    align="center"
    color="secondary"
    block
    height="120"
  >
    <div class="text-body1 text-sm-h5">{{ linkText }}</div>
  </v-btn>
</template>

<script>
  export default {
    props: {
      linkText: String,
      linkUrl: String,
      isBlank: Boolean,
    },

    computed: {
      isInternal() {
        return this.linkUrl.startsWith("/");
      },
    },
  };
</script>
